/*global addiesaas, _ */
/**
 * This module shows add card popup in profile after logging in (from login page or in profile page)
 * The popup is shown only when user does not have any card registered (user.playcards_count === 0)
 */

const MOUNTED = 're-profile.mounted'
const AUTH_REDIRECT = 'auth.redirect'

const state = {showing: false}

export default (Bus) => {
  Bus.$on(AUTH_REDIRECT, async () => {
    localStorage.setItem(AUTH_REDIRECT, 1)
  })

  Bus.$on(MOUNTED, async (vm) => {

    vm.$watch('authenticated', async (isAuthenticated, wasAuthenticated) => {
      if (isAuthenticated && !wasAuthenticated) {
        await showAddCardModal.call(vm)
      }
    })

    const isAuthRedirect = localStorage.getItem(AUTH_REDIRECT) * 1
    localStorage.removeItem(AUTH_REDIRECT)
    if (isAuthRedirect) {
      await showAddCardModal.call(vm)
    }
  })
}
const showAddCardModal = async function () {
  const user = this.user
  const cardCount = user && user.playcards_count
  if (state.showing || !user || cardCount) {
    return
  }
  state.showing = true
  const card = await addiesaas.$fn.modals.showModalAsync('re-add-card', {
    componentAttrs: {
      settings: 'page.profile.tab.playcards.addCard',
      translations: 'page.profile.tab.playcards.addCard',
      standalone: true
    },
    props: {
      containerClass: ['re-modal-md', 'add-modal']
    }
  })
  state.showing = false

  if (_.isObject(card)) {
    this.profileLocationId = card.location_id
    this.select('playcards')
  }
}
